/* 

This store is different from all of the others. It's main job is to track 
all of the action that have been requested while offline and them to run 
them when we return to network connectivity. The core of this store is 
the actions array. This array contains ActionTrackerEntry objects. 

ActionTrackerEntry objects are used to record an action and their payload.
The actions are stored as a string to be used by the applyActions method 
in this store. 

The principle is simple, store all of the actions as a string ready for a 
root dispatch and the payload and just fire them off

*/

// initial state
const state = {
  loading: false,
  error: false,
  actions: {},
  poisWaitingAction: []
};

const getters = {
  loading(state) {
    return state.loading;
  },
  error(state) {
    return state.error;
  },
  actions(state) {
    return state.actions;
  },
  poisWaitingAction(state) {
    return state.poisWaitingAction;
  }
};

// actions
const actions = {
  applyActions({ commit, state, dispatch }) {
    commit("setLoading", true);
    commit("clearError");
    let keys = Object.keys(state.actions);
    for (let index = 0; index < keys.length; index++) {
      const action = state.actions[keys[index]];
      dispatch(action.action, action.payload, {
        root: true
      }).then(() => {
        commit("removeActionByIndex", keys[index]);
      });
    }
    commit("clearPoisWaitingAction");
  }
};

// mutations
const mutations = {
  setLoading(state, payload) {
    state.loading = payload;
  },
  clearLoading(state) {
    state.loading = false;
  },
  setError(state, payload) {
    state.error = payload;
  },
  clearError(state) {
    state.error = false;
  },
  addActions(state, payload) {
    let payloadObj = {};
    payloadObj[payload.id] = payload;
    state.actions = { ...state.actions, ...payloadObj };
  },
  removeActionByIndex(state, id) {
    let current = state.actions;
    delete current[id];
    state.actions = { ...current };
  },
  clearActions(state) {
    state.actions = false;
  },
  setPoisWaitingAction(state, payload) {
    state.poisWaitingAction = payload;
  },
  addPoisWaitingAction(state, payload) {
    // check if the id is already in the list
    if (!state.poisWaitingAction.includes(payload)) {
      state.poisWaitingAction.push(payload);
    }
  },
  clearPoisWaitingAction(state) {
    state.poisWaitingAction = [];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
